import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';

// user
import user_basic_information from './modules/user/user_basic_information';
import user_config from './modules/user/config';
import user_authorities from './modules/user/user_authorities';
import listview_remain_information from './modules/user/listview_remain_information';
import plan_trial_remain_information from './modules/user/plan_trial_remain_information';
import mail_list from './modules/user/mail_list';
import mail_stepmail_edit from './modules/user/mail_stepmail_edit';
import mail_delivery_list from './modules/user/mail_delivery_list';
import mail_template_setting from './modules/user/mail_template_setting';
import person_list from './modules/user/person_list';
import company_list from './modules/user/company_list';
import pages_list from './modules/user/pages_list';
import scenario_pages_list from './modules/user/scenario_pages_list';
import person_master from './modules/user/person_master';
import seminar_applicant_list from './modules/user/seminar_applicant_list';
import seminar_enquete_result_list from './modules/user/seminar_enquete_result_list';
// admin
import admin_basic_information from './modules/admin/admin_basic_information';
import admin_authorities from './modules/admin/admin_authorities';
import admin_config from './modules/admin/config';
// components
import bee_free_editor from './modules/components/bee_free_editor';
import sender_list from './modules/components/sender_list';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        // user専用
        user: {
            namespaced: true,
            modules: {
                user_basic_information, // ユーザー基本情報
                user_config, // 設定情報
                user_authorities, // 権限情報
                listview_remain_information, // 閲覧可能日数の情報
                plan_trial_remain_information, // プラントライアル残日数の情報
                mail_list, // メール作成・配信予約
                mail_stepmail_edit, // ステップメール編集
                mail_delivery_list, // メール配信 配信リスト
                mail_template_setting, // メール配信 テンプレート設定
                person_list, // 個人リスト
                company_list, // 企業リスト
                pages_list, // ページ一覧
                scenario_pages_list, // シナリオページ一覧
                person_master, // 個人マスタ
                seminar_applicant_list, // 申込者一覧
                seminar_enquete_result_list, // アンケート結果
            }
        },
        // admin専用
        admin: {
            namespaced: true,
            modules: {
                admin_basic_information, // ユーザー基本情報
                admin_config, // 設定情報
                admin_authorities // 権限情報
            }
        },
        // components専用
        components: {
            namespaced: true,
            modules: {
                bee_free_editor, // BeeFreeエディタ
                sender_list // 送信者の選択
            }
        }
    },
    plugins: [createPersistedState()] // vuexに'vuex-persistedstate'を追加
});
